import React, { createContext, useContext, useEffect, useState } from "react";
import { logoutRequest } from "../../api/authApi";
import api from "../../api/axios";

type AuthContextType = {
  isAuthenticated: boolean;
  token: string | null;
  login: (token: string) => void;
  logout: () => Promise<void>;
};

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  token: null,
  login: () => {},
  logout: async () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("token")
  );
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    !!localStorage.getItem("token")
  );

  const login = (newToken: string) => {
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setIsAuthenticated(true);
    api.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
  };

  const logout = async () => {
    try {
      await logoutRequest();
    } catch (error) {
      console.warn("Erro no logout remoto:", error);
    } finally {
      localStorage.clear();
      setToken(null);
      setIsAuthenticated(false);
      delete api.defaults.headers.common["Authorization"];
    }
  };

  useEffect(() => {
    const localToken = localStorage.getItem("token");
    setToken(localToken);
    setIsAuthenticated(!!localToken);
    if (localToken) {
      api.defaults.headers.common["Authorization"] = `Bearer ${localToken}`;
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);